import React, { useEffect } from 'react'
import { useState } from 'react';
import Home from '../Home'
import GushMenuBar from '../../components/GushMenuBar/GushMenuBar';
import Board from '../Board/Board';
import { ReadyState } from 'react-use-websocket';
import Cover from '../../components/Cover/Cover';
import Splash from "../../components/Splash";
import Intro from "../../components/Intro";
import GameEndedHostGone from './GameEnded';
import { forgetGame } from '../Home/join';
import { useParams } from 'react-router';
import { onLanguageChange, t } from '../../i18n';

export default function Game() {

  let { game } = useParams();

  const [gameCode, setGameCode] = useState(game);
  const [playerInfo, setPlayerInfo] = useState({});
  const [userName, setUserName] = useState('');
  const [didLogIn, setDidLogin] = useState(false);
  const [connectionState, setConnectionState] = useState(ReadyState.CLOSED);
  const [randomWon, setRandomWon] = useState(false)
  const [gameEnded, setGameEnded] = useState(false)
  const [didShowSplash, setDidShowSplash] = useState(sessionStorage.getItem("didShowSplash") === "true")
  const [didShowIntro, setDidShowIntro] = useState(() => {
    try { return localStorage.getItem("didShowIntro") === "true" } catch { return false }
  })
  const [splashTimeUp, setSplashTimeUp] = useState(false)
  const [homeReady, setHomeReady] = useState(false)
  const [splashLeaving, setSplashLeaving] = useState(false)
  const [isLeaving, setIsLeaving] = useState(false)
  // A language selection re-renders every screen below with its state kept (no remount: typed input stays).
  const [, setLanguageChanges] = useState(0)

  useEffect(() => onLanguageChange(() => setLanguageChanges(n => n + 1)), [])

  useEffect(() => {
    if (game) {
      setGameCode(game)
    }
  }, [game])

  useEffect(() => {
    if (didShowSplash) return
    const timer = setTimeout(() => setSplashTimeUp(true), 5000)
    return () => clearTimeout(timer)
  }, [didShowSplash])

  // Home loads under the splash; after 5s and once Home (or a rejoined game) can show, the splash fades out for 200ms
  useEffect(() => {
    if (didShowSplash || !splashTimeUp || !(homeReady || didLogIn)) return
    setSplashLeaving(true)
    const done = setTimeout(() => {
      setDidShowSplash(true)
      sessionStorage.setItem("didShowSplash", true.toString())
    }, 200)
    return () => clearTimeout(done)
  }, [didShowSplash, splashTimeUp, homeReady, didLogIn])

  const handleIntroDone = () => {
    try { localStorage.setItem("didShowIntro", "true") } catch {}
    setDidShowIntro(true)
  }

  const handleStartGamePressed = (gameCode, playerInfo, userName) => {
    localStorage.setItem("userName", userName)
    sessionStorage.setItem("gameCode", gameCode)
    setGameCode(gameCode);
    setPlayerInfo(playerInfo);
    setUserName(userName)
    setDidLogin(true);
  }

  // Unmounting Board closes the websocket, which suspends the player on the server; the seat key stays, so
  // joining again with the same code and name takes the seat back.
  const goHome = () => {
    sessionStorage.removeItem("gameCode")
    setIsLeaving(false)
    setRandomWon(false)
    setDidLogin(false)
  }

  // A game that ended has no seat to come back to.
  const handleBackHome = () => {
    forgetGame(gameCode, userName)
    setGameEnded(false)
    goHome()
  }

  const handleConnectionStateChanged = (readyState) => {
    setConnectionState(readyState);
  }

  const handleRandomWon = () => {
    setRandomWon(true)
  }

  const handleGameEnded = () => {
    setGameEnded(true)
  }

  return (<>
    {randomWon
        ? <Cover onHome={handleBackHome} />
        : gameEnded
          ? <GameEndedHostGone onHome={handleBackHome} />
          : !didLogIn
            ? <Home onUserLoggedIn={handleStartGamePressed} onReady={() => setHomeReady(true)} />
            : <main className="screen">
              <GushMenuBar
                connectionState={connectionState}
                playerName={userName}
                gameCode={gameCode}
                onLeave={() => setIsLeaving(true)}
                isLeaving={isLeaving} />
              <Board
                gameCode={gameCode}
                playerInfo={playerInfo}
                onReadyStateChanged={handleConnectionStateChanged}
                onRandomWon={handleRandomWon}
                onGameEnded={handleGameEnded} />
              {isLeaving && <>
                <div className="scrim"></div>
                <section className="sheet" role="dialog" aria-modal="true" aria-labelledby="leave-q">
                  <span className="grab" aria-hidden="true"></span>
                  <p id="leave-q" className="h-l" style={{ textAlign: 'center' }}>{t('game.leaveConfirm')}</p>
                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0, 1fr))', gap: 12 }}>
                    <button className="btn btn-primary" onClick={goHome}>{t('common.yes')}</button>
                    <button className="btn" onClick={() => setIsLeaving(false)}>{t('common.no')}</button>
                  </div>
                </section>
              </>}
            </main>}
    {!didShowSplash
      ? <div className="overlay"><Splash leaving={splashLeaving} /></div>
      : !didShowIntro && <div className="overlay"><Intro onDone={handleIntroDone} /></div>}
  </>)
}
